import styled, { css } from 'styled-components';

import Icon from '../../../../_shared/components/Icon';
import Detail from '../../../../_shared/components/Detail';

const disclosureMessageVariant = {
  NO: css`
    font-family: ${({ theme }) => theme.FONT.REGULAR};
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  `,
  YES: css`
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  `
};

export const Container = styled.div`
  width: 100%;
  height: 100%;
  max-height: 75vh;
`;

export const CloseButton = styled.button`
  display: block;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.COLORS.TRANSPARENT};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  padding-top: 24px;
  padding-bottom: 36px;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.WIDE};
  height: 24px;
  line-height: 24px;
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  background: ${({ theme }) => theme.COLORS.BASE};
  width: 390px;
  text-align: left;
  padding-left: 0;
`;

export const Content = styled.div`
  width: 100%;
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  line-height: 24px;
`;

export const DisclosureIcon = styled(Icon).attrs(props => ({
  icon: props.icon
}))`
  width: 26px;
  height: 36px;
  margin-right: 18px;
`;

export const DisclosureText = styled.div`
  padding-top: 9px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  line-height: initial;
`;

export const CloseIcon = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  width: 10px;
  height: 11px;
  padding-bottom: 1px;
`;

export const DisclosuresContainer = styled.div`
  margin-top: 24px;
`;

export const Disclosures = styled.div`
  width: 390px;
  height: 36px;
  border-radius: 3px;
  background: ${({ theme }) => theme.COLORS.NEUTRAL_5};
  padding: 24px;
  font-family: ${({ theme }) => theme.FONT_FACES.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE_SIZE};
  line-height: 16px;
  font-color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin-bottom: 2px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledDisclosureTitle = styled(Detail.Value)`
  ${props => disclosureMessageVariant[props.invalid]}
  font-family: ${({ theme }) => theme.FONT_FACES.REGULAR};
`;

export const StyledDisclosureValue = styled(Detail.Value)`
  ${props => disclosureMessageVariant[props.invalid]}
  margin-left: auto;
  font-family: ${({ theme }) => theme.FONT_FACES.REGULAR};
`;
